<template>
  <div class="step-imagens">
    <CRow>
      <CCol :md="temMobile ? 6 : 12">
        <SeletorImagem
          :label="tamanhoDesktop"
          v-model="item.imagem_desktop"
        />
        <div v-if="validacao.firstError('item.imagem_desktop')" class="message">
          {{ validacao.firstError("item.imagem_desktop") }}
        </div>
      </CCol>
      <CCol md="6" v-if="temMobile">
        <SeletorImagem :label="tamanhoMobile" v-model="item.imagem_mobile" />
        <div v-if="validacao.firstError('item.imagem_mobile')" class="message">
          {{ validacao.firstError("item.imagem_mobile") }}
        </div>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import SeletorImagem from "@/components/base/SeletorImagem.vue";
import {
  campoVisivel,
  getTamanhoDesktop,
  getTamanhoMobile,
} from "../helpers/bannerLabels";

export default {
  name: "StepImagens",
  components: { SeletorImagem },
  props: {
    item: {
      type: Object,
      required: true,
    },
    validacao: {
      type: Object,
      required: true,
    },
  },
  computed: {
    temMobile() {
      return campoVisivel(this.item.local, "imagemMobile");
    },
    tamanhoDesktop() {
      return getTamanhoDesktop(this.item.local);
    },
    tamanhoMobile() {
      return getTamanhoMobile(this.item.local);
    },
  },
};
</script>

<style scoped>
.step-imagens {
  min-height: 220px;
}

.message {
  font-size: 11px;
  color: #d92d20;
  margin-top: 2px;
}
</style>
